const React = require('react');
const isNode = (typeof process !== 'undefined');

class PropertyType extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const types = Array.isArray(this.props.type) ? this.props.type : [this.props.type];
        return (
        <div className="rental__fact">
            <span className="rental__fact-header">Type lokale</span>
            <div className="rental__fact-value">
                <ul>
                    {types.map(type => <li>{type._text}</li>)}
                </ul>
            </div>
        </div>
        )
    }
}

module.exports = PropertyType;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/PropertyComponents/PropertyType/index.jsx